import { render, staticRenderFns } from "./ShowCompanytwo.vue?vue&type=template&id=0d9b38b4&scoped=true&"
import script from "./ShowCompanytwo.vue?vue&type=script&lang=js&"
export * from "./ShowCompanytwo.vue?vue&type=script&lang=js&"
import style0 from "./ShowCompanytwo.vue?vue&type=style&index=0&id=0d9b38b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b38b4",
  null
  
)

export default component.exports